export const enum IRefreshEnum {
  checkEveryMs = 30_000,
  idleAfterMs = 120_000,
  koaValidationStartHour = 12,
  clockSkewSeconds = 300,
}
